import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import {
  GetEngagementsQuery,
  GetEngagementsResponse,
} from './types/Engagement';

type UserId = number | 'me';

export default (makeCall: MakeCall) =>
  (userId: UserId = 'me', query?: GetEngagementsQuery) =>
    makeCall<GetEngagementsResponse>('GET', `/api/v2/user/${userId}/tenants`, {
      query,
    });
